import React from 'react'

import ActionIcon from '@components/UI/ActionIcon'
import StopPropagation from '@components/UI/StopPropagation/StopPropagation'
import { useModal } from '@context/Modal'
import { EventTrackingNames } from '@enums'
import Theme from '@theme'
import BrandFansInfluencerIdentityGroups from '../Groups'
import BrandFanInfluencerIdentityRowTrackedRoute from './TrackedRoute'

interface IProps {
  brandFanMemberId?: number
  brandFanGroupId?: number
  identityId: number
  active?: boolean
}

const BrandFanInfluencerIdentityRowActions: React.FC<IProps> = ({
  identityId,
  brandFanMemberId,
  brandFanGroupId,
  active,
}) => {
  const { showModal, hideModal } = useModal()
  const onOpenModal = () =>
    showModal(BrandFansInfluencerIdentityGroups, {
      brandFanMemberId,
      brandFanGroupId,
      identityId,
      hideModal,
    })
  return (
    <StopPropagation>
      <BrandFanInfluencerIdentityRowTrackedRoute
        eventName={EventTrackingNames.BrandFansGroupsModal}
        identityId={identityId}
      >
        <ActionIcon
          data-testid="brand-fan-groups-modal-trigger"
          highlighted={active}
          glyph="plus"
          color={active ? Theme.primaryColor : Theme.defaultColor}
          size={1.125}
          onClick={onOpenModal}
        />
      </BrandFanInfluencerIdentityRowTrackedRoute>
    </StopPropagation>
  )
}

export { BrandFanInfluencerIdentityRowActions }
export default BrandFanInfluencerIdentityRowActions
